module.exports = __webpack_public_path__ + "static/media/GR.0ec4ae93.png";